import cx from 'classnames';
import type { BlockViewProps } from '@plone/types';

import styles from '@redturtle/qubicaamf-theme/components/Blocks/OurServices/styles.module.css';
import type { OurServicesData } from '@redturtle/qubicaamf-theme/components/Blocks/OurServices/schema';
import ItemMenu from './menu';
import config from '@plone/registry';

type Props = BlockViewProps & {
  data: OurServicesData;
};

export default function ViewOurServicesBlock({
  data,
  className,
  style,
}: Props) {
  const Container = config.getComponent('Container').component || 'div';

  return (
    <section
      className={cx('block-ourservices', styles.blockourservice, className)}
      style={style}
      aria-label={data.title}
    >
      <Container
        className={cx('block-ourservices-container', styles.container)}
      >
        <ItemMenu
          items={data.services || []}
          title={data.title}
          isEditMode={false}
        />
      </Container>
    </section>
  );
}
